import React, { useEffect, useRef, createElement } from "react";
import { useNavigate } from "react-router-dom";
import { X } from "lucide-react";
interface BetaSignupProps {
  isOpen: boolean;
  onClose: () => void;
}
export const BetaSignup = ({
  isOpen,
  onClose
}: BetaSignupProps) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const navigate = useNavigate();
  useEffect(() => {
    if (!containerRef.current || !isOpen) return;
    try {
      const iframe = document.createElement("iframe");
      iframe.src = "https://forms.zohopublic.eu/leanops/form/usegigiaijoinbeta/formperma/3w_Zm0ZyLQESGCTEMyC9M4bPVP7hEC9RZVik1TqXvCc";
      iframe.style.border = "none";
      iframe.style.height = "336px";
      iframe.style.width = "90%";
      iframe.style.transition = "all 0.5s ease";
      // Listen for form submission
      window.addEventListener("message", event => {
        if (event.data === "zohoFormSubmitted") {
          onClose();
          navigate("/dashboard");
        }
      });
      containerRef.current.appendChild(iframe);
    } catch (e) {
      console.error("Error loading form:", e);
    }
    return () => {
      if (containerRef.current) {
        containerRef.current.innerHTML = "";
      }
    };
  }, [isOpen, navigate, onClose]);
  if (!isOpen) return null;
  return <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50" data-id="element-95">
      <div className="relative w-[500px]" data-id="element-96">
        <button onClick={onClose} className="absolute -top-10 right-0 text-white hover:text-gray-200" data-id="element-97">
          <X size={24} data-id="element-98" />
        </button>
        <div id="zf_div_3w_Zm0ZyLQESGCTEMyC9M4bPVP7hEC9RZVik1TqXvCc" ref={containerRef} className="bg-white rounded-lg overflow-hidden flex justify-center" data-id="element-99" />
      </div>
    </div>;
};